/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import './Experience.css';
import { motion } from "framer-motion";


function Experience() {
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [showMore, setShowMore] = useState(false);

  const experiences = [
    {
      name: 'Hydro One',
      logo: '/images/hydro_one.png',
      description: (
        <span>
          Collaborated within a cross-functional team to develop a software solution utilizing <span className="green-text"> Agile methodology</span>, overseeing the complete project lifecycle through <span className="green-text"> Jira</span>, resulting in a <span className="green-text"> 30%</span> improvement in team efficiency. Contributed to a <span className="green-text"> province-wide</span> network upgrade that enhanced performance by <span className="green-text"> 5 times</span> for users across Ontario. Automated provisioning processes using <span className="green-text"> Python</span> and <span className="green-text"> JavaScript</span>, achieving an <span className="green-text"> 85%</span> boost in operational efficiency. Additionally, addressed and resolved critical software defects and maintained database integrity, supporting the functionality of <span className="green-text">millions of services.</span>
          <br />
          <br />
          <a href="https://www.linkedin.com/posts/acronym-solutions_coopexperience-engineering-computerengineering-activity-7186795456536932352-HmXs?utm_source=share&utm_medium=member_desktop" target="_blank" rel="noopener noreferrer" className="linkedin-button">
          View LinkedIn Post 
          <img src="/images/external-link.png" alt="External Link Icon"></img>
          </a>
        </span>
      ),
      title: 'Hydro One @ Acronym Solutions Inc.',
      position: 'Software Engineer Intern',
      timeframe: 'May 2023 - May 2024'
    },
    {
      name: 'IBM',
      logo: '/images/ibm.png',
      description: (
        <span>
          Delivered workshops on <span className="green-text">enterprise computing</span> and programming, mentoring peers in both <span className="green-text">Node.js</span> and <span className="green-text">Python</span>. Selected from a pool of over <span className="green-text">300 candidates</span> to serve as the <span className="green-text">Student Ambassador</span> for Z Mainframe Technology. Collaborated with IBM professionals to develop and present official materials, and facilitated multiple events aimed at educating peers on the latest advancements in Z Mainframe Technology.
          <br />
          <br />
          <a href="https://www.linkedin.com/posts/aboudjalal_yesterday-officially-marked-the-day-we-brought-activity-7303190295666429952-2OYX?utm_source=share&utm_medium=member_desktop&rcm=ACoAADPyWaQBwgdWtnYdnX3hY4uNPQ3ibgknXjE" target="_blank" rel="noopener noreferrer" className="linkedin-button">
            View LinkedIn Post 
            <img src="/images/external-link.png" alt="External Link Icon"></img>
          </a>
        </span>
      ),
      title: 'IBM',
      position: 'Z Ambassador',
      timeframe: 'September 2022 - Present'
    }
    ,
    {
      name: 'University of Waterloo',
      logo: '/images/UniversityOfWaterloo_logo_vert_bk.png',
      description: (
        <span>
          Conducted research leveraging <span className="green-text">Large Language Models (LLMs)</span> including LLaMA and ChatGPT to analyze and interpret qualitative health data, focusing on their potential to revolutionize healthcare research. This involved testing and evaluating the application of LLMs in extracting meaningful patterns from complex datasets, enabling deeper insights into patient experiences, treatment effectiveness, and health outcomes. By comparing model performance across tasks like <span className="green-text">text summarization</span>, <span className="green-text">sentiment analysis</span>, and <span className="green-text">thematic coding</span>, the research aimed to enhance the accuracy and efficiency of data interpretation. Additionally, the project explored the integration of these models into healthcare workflows, assessing their potential to support <span className="green-text">evidence-based decision-making</span> and improve overall outcomes in digital health research.
          <br />
          <br />
          <a href="https://uwaterloo.ca/digital-intelligence-for-public-health/profiles/aboud-jalal" target="_blank" rel="noopener noreferrer" className="linkedin-button">
            Visit my public profile 
            <img src="/images/external-link.png" alt="External Link Icon"></img>
          </a>
        </span>
      ),
      title: 'University of Waterloo',
      position: 'Research Assistant',
      timeframe: 'September 2024 - Present',
    }
    ,
    {
      name: 'York University',
      logo: '/images/york_university.png',
      description: (
        <span>
          My research focuses on developing advanced <span className="green-text">direct-georeferencing technology</span> through <span className="green-text">multisensor integrated kinematic positioning</span> and navigation systems. By integrating GNSS receivers, IMUs, cameras, LiDAR, and ultrasonic beacons, the goal is to enable real-time data acquisition and precise 3D trajectory estimation. The work emphasizes <span className="green-text">sensor fusion algorithms</span>, combining data from multiple sources to achieve optimal results, such as <span className="green-text">GNSS/IMU/LiDAR integration</span>. Using methodologies like <span className="green-text">Kalman filtering</span> and <span className="green-text">least squares</span>, alongside robust statistical testing, the project ensures high-accuracy positioning. Development is undertaken in <span className="green-text">C/C++</span> across <span className="green-text">Linux</span> and <span className="green-text">Windows</span> environments, enabling innovative solutions for cutting-edge R&D applications.
        </span>
      ),
      title: 'York University',
      position: 'Research Assistant',
      timeframe: 'January 2025 - Present',
    }

    
  ];

  const additionalExperiences = [
    {
      name: 'YEC',
      logo: '/images/yec.png',
      description: (
        <span>
          Directed a team of <span className="green-text">15+ members</span> in successfully organizing the <span className="green-text">York Engineering Competition </span>(YEC), one of the largest student-led engineering events at York University. Spearheaded the planning and execution of multiple competition streams, engaging <span className="green-text">over 500 participants</span> across <span className="green-text">9 disciplines</span>, including design, programming, debate, communication, and bio-engineering challenges. Secured sponsorships from industry leaders, expanding the event budget by <span className="green-text">50%</span> and enabling the inclusion of advanced resources, prizes, and promotional activities.
      <br />
          <br />
          <a href="https://www.linkedin.com/posts/aboudjalal_yorkengineeringcompetition-yec2024-futureengineers-activity-7258584889837400066-Qj_L?utm_source=share&utm_medium=member_desktop" target="_blank" rel="noopener noreferrer" className="linkedin-button">
            Visit LinkedIn Post 
            <img src="/images/external-link.png" alt="External Link Icon"></img>
          </a>
        </span>
      ),
      title: 'York Engineering Competition',
      position: 'Chair',
      timeframe: 'May 2024 - Present',
    },
    {
      name: 'STEM Fellowship',
      logo: '/images/stem_fellowship.png',
      description: (
        <span>
          Conducted advanced research leveraging <span className="green-text">AI-driven data analysis</span> to examine the intersection of Autism Spectrum Disorder (ASD) and mental health, deriving actionable insights from over <span className="green-text">50 complex datasets</span>. Applied <span className="green-text">meta-analysis techniques</span> utilizing <span className="green-text">pandas</span> to synthesize data, producing significant findings on the social and biological implications of ASD. Presented research outcomes at the STEM Fellowship Research Competition at Microsoft's headquarters, addressing an audience of over <span className="green-text">300 participants</span>, including industry leaders and academics.
        </span>
      ),
      title: 'STEM Fellowship Research',
      position: 'Researcher',
      timeframe: 'June 2024 - August 2024'
    }

    ,
    // {
    //   name: 'YEC',
    //   logo: '/images/yec.png',
    //   description: (
    //     <span>
    //       Directed a team of <strong>15+ members</strong> in organizing the <strong>York Engineering Competition</strong>, engaging <strong>over 500 participants</strong> and securing sponsorships that expanded the event budget by <span className="highlight">50%</span>. Enhanced participant experience through innovative event formats and workshops, fostering a dynamic and inclusive environment for engineering students.
    //     </span>
    //   ),
    //   title: 'York Engineering Competition',
    //   position: 'Chair',
    //   timeframe: 'May 2024 - Present',
    // }
  ];

  const handleClick = (experience) => {
    setSelectedExperience(experience);
  };

  const handleClose = () => {
    setSelectedExperience(null);
  };

  const handleShowMore = (e) => {
    e.preventDefault(); // Prevent default anchor behavior
    setShowMore(!showMore); // Toggle the showMore state
  };

  return (
    <section id="experience" className="experiences-section">
      {/* Title Animation */}
      <motion.div
        className="section-title"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.6, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <h1>Experiences.</h1>
      </motion.div>

      {/* Animated Line */}
      <motion.div
        className="line"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        transition={{ duration: 3, ease: "easeOut" }}
        viewport={{ once: true }}
      ></motion.div>
        
        
        <div className="experiences-container">
        {experiences.map((experience, index) => (
          <div
            key={index}
            className="experience-item"
            onClick={() => handleClick(experience)}
          >
            <img
              src={experience.logo}
              alt={experience.name}
              className="experience-logo"
            />
            <p>{experience.name}</p>
          </div>
        ))}
      </div>
      {showMore && (
        <div className="experiences-container additional">
          {additionalExperiences.map((experience, index) => (
            <div
              key={index}
              className="experience-item"
              onClick={() => handleClick(experience)}
            >
              <img
                src={experience.logo}
                alt={experience.name}
                className="experience-logo"
              />
              <p>{experience.name}</p>
            </div>
          ))}
        </div>
      )}
      <motion.div
        className="line2"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        transition={{ duration: 2, delay: 0.2, ease: "easeOut" }}
        viewport={{ once: true }}
      ></motion.div>
            <motion.div
        className="line3"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        transition={{ duration: 2, delay: 0.2, ease: "easeOut" }}
        viewport={{ once: true }}
      ></motion.div>
      <div className="show-more">
        <a href="#" onClick={handleShowMore}>
          {showMore ? 'Show less' : 'Show more'}{' '}
          <img
            src="/images/showmore_arrow.png"
            className={`arrow-icon ${showMore ? 'rotated' : ''}`}
            alt="arrow"
          />
        </a>
      </div>

      {selectedExperience && (
        <div className="popup">
          <div className="popup-content">
            <img 
              src="/images/closecard.png" 
              alt="Close" 
              className="close-btn"
              onClick={handleClose} 
            />
            <h2>{selectedExperience.title}</h2>
            <p className="position">{selectedExperience.position}</p>
            <p className="timeframe">{selectedExperience.timeframe}</p>
            <p>{selectedExperience.description}</p>
          </div>
        </div>
      )}
    </section>
  );
}

export default Experience;
